import { render } from "./CompoundMenu.vue?vue&type=template&id=9c0f55aa"
import script from "./CompoundMenu.vue?vue&type=script&lang=js"
export * from "./CompoundMenu.vue?vue&type=script&lang=js"

import "./CompoundMenu.vue?vue&type=style&index=0&id=9c0f55aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__